import { getMinCostsByCampaignService } from '~/modules/retailMedia/services/campaign/min-cost'
import { ad as service } from '~/modules/retailMedia/services/industry'

import { types } from './constants'

export const getMinCosts = ({
  body,
  campaignId,
  adType
}: GetMinCostActionsProps) => {
  const isProduct = adType === 'product'

  const actions = {
    product: () => service.getMinCosts({ body }),
    others: () => getMinCostsByCampaignService(campaignId)
  }

  const payload = isProduct ? actions.product : actions.others

  return {
    type: types.getMinCosts,
    payload: payload(),
    errorFeedbackMsg: 'Erro ao buscar custos mínimos da campanha'
  }
}

export default {
  getMinCosts
}
